document.addEventListener('DOMContentLoaded', () => {
    document.querySelector('body').classList.add('is-loaded');
})